const BASE_URL = "https://www.msu.edu.in";

export function toAbsoluteUrl(url) {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  return `${BASE_URL}${url.startsWith("/") ? "" : "/"}${url}`;
}

export function buildBreadcrumbSchema(items = [], currentPathname = "") {
  const schemaItems = [
    {
      "@type": "ListItem",
      position: 1,
      name: "Home",
      item: `${BASE_URL}/`,
    },
    ...items.map((item, index) => {
      const isLast = index === items.length - 1;
      const href = item.href || "";
      const listItem = {
        "@type": "ListItem",
        position: index + 2,
        name: item.label || "",
      };

      if (href) {
        listItem.item = toAbsoluteUrl(href);
      }

      return listItem;
    }),
  ];

  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: schemaItems,
  };
}

export function stringifyJsonLd(data) {
  return JSON.stringify(data).replace(/</g, "\\u003c");
}
